

import { SubDomain } from "../SubDomain";
import Asset from './Asset.js';
import AssetMap from './AssetMap.js';

export default class AssetsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Asset.MODEL_NAME);
    this.storage = storage;
  }
  
  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Asset(this.domain, item);
      }
    }

    return new Asset(this.domain);
  }
  
  findByCompany(company) {
    var objects = this.list();
    var map = new AssetMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var asset = new Asset(this.domain, item);
      if (asset.company().id() === company.id()) {
        map.add(asset);
      }
    }
    return map;
  }
}